import { useMutation } from "@tanstack/react-query";
import { LoyaltyService } from "../../services/loyalty.service";
import { ILoyaltySettingsUpdate } from "../../models/Loyalty";

export const useLoyaltySettingsMutations = () => {
  const { mutate: updateLoyaltySettings } = useMutation<
    any,
    Error,
    { model: ILoyaltySettingsUpdate }
  >({
    mutationFn: async ({ model }) => LoyaltyService.updateLoyaltySettings(model),
  });

  return {
    updateLoyaltySettings,
  };
};
